import { get } from 'lodash';
import { getFormValues } from 'redux-form';
import { put, select, takeEvery } from 'redux-saga/effects';
import { startAsyncValidation, stopAsyncValidation } from 'redux-form';

import {
  authSignUpSuccess,
  authSignUpError,
  authSignUp,
  authSubmitSignUpForm,
  authSetGlobalFormErrors,
} from '../actions';
import { createApiRequestSaga } from '../../../modules/api/saga';
import { SIGN_UP_FORM } from '../SignUpForm';
import { ENDPOINTS } from '../../../modules/api/endpoints';
import { IAction } from '../../../interfaces/IAction';
import { getType } from 'typesafe-actions';
import { trackEvent } from '../../../utils/Analytics';

const signUpSaga = createApiRequestSaga({
  actionSuccess: authSignUpSuccess,
  actionError: authSignUpError,
});

function* signUpFormWatcher() {
  const data = yield select(getFormValues(SIGN_UP_FORM));

  yield put(
    authSignUp({
      url: ENDPOINTS.AUTH.SIGN_UP,
      method: 'post',
      data,
    }),
  );

  yield put(startAsyncValidation(SIGN_UP_FORM));
}

function* watchSignUpResults(action: IAction) {
  const error = get(action, ['payload', 'errors', 'error']);

  if (!error) {
    trackEvent('Signup', {});
  }

  yield put(
    authSetGlobalFormErrors({
      formName: SIGN_UP_FORM,
      errors: [error],
    }),
  );

  yield put(stopAsyncValidation(SIGN_UP_FORM, {}));
}

export default function* authSignUpSaga() {
  yield takeEvery(getType(authSubmitSignUpForm), signUpFormWatcher);
  yield takeEvery([getType(authSignUp)], signUpSaga);
  yield takeEvery([getType(authSignUpSuccess), getType(authSignUpError)], watchSignUpResults);
}



// WEBPACK FOOTER //
// ./src/containers/Auth/saga/signUpSaga.ts